module.exports = __webpack_public_path__ + "static/img/power4.cd690b3b.png";